import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { VendorOffersComponent } from './vendor-offers/vendor-offers.component';
import { VendorBranchesComponent } from './vendor-branches/vendor-branches.component';
import { CategoriesService } from '../../features/categories/services/categories.service';
import { VendorsService } from '../../features/vendors/services/vendors.service';

@Component({
  selector: 'app-vendor-details',
  templateUrl: './vendor-details.component.html',
  styles: ``
})
export class VendorDetailsComponent {

  @Output() close = new EventEmitter(false);
  @Input() selectedId!: string;
  @Input() Permissions: any;
  dataLoading: boolean = false;

  center!: google.maps.LatLngLiteral;
  options!: google.maps.MapOptions;
  zoom = 6;
  mapValues!: any;

  vendorDetails!: any
  subCategoris!: any[];
  subCategorisLoading = false;

  mapOptions!: google.maps.MapOptions
  Marker!: google.maps.MarkerOptions
  constructor(private dialog: MatDialog,
    private service: VendorsService,
    private categoryService: CategoriesService,
    private translate: TranslateService) {

  }

  ngOnInit(): void {
    this.getVendorDetails()

  }

  getVendorDetails() {
    this.dataLoading = true;
    this.service.VendorProfile(this.selectedId).subscribe((res) => {
      this.dataLoading = false;
      this.vendorDetails = res.data;
      this.Marker = {
        position: {
          lat: Number(this.vendorDetails?.map_lat),
          lng: Number(this.vendorDetails?.map_lang)
        },
        clickable: true,
        label: { text: this.vendorDetails?.address ? this.vendorDetails?.address : '', className: 'map_lable' }
      }

      this.mapOptions = {
        center: {
          lat: Number(this.vendorDetails?.map_lat),
          lng: Number(this.vendorDetails?.map_lang)
        },
        mapId: 'customMap6',
        scrollwheel: true,
        disableDoubleClickZoom: true,
        mapTypeId: 'roadmap',
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: false
      };
    })
  }


  getSubCategories(parentId: any, i: any) {
    this.vendorDetails.main_category[i].loading = true;
    this.categoryService.getVendorSubCategories(this.selectedId, parentId).subscribe((data: any) => {
      this.subCategoris = data.data;
      this.vendorDetails.main_category[i].subCategoris = data.data;
      this.vendorDetails.main_category[i].loading = false;

    })
  }

  openBranchesMenu() {
    const dialogRef = this.dialog.open(VendorBranchesComponent, {
      width: '540px',
      data: { vendorId: this.selectedId }
    });
  }

  openOffersMenu() {
    const dialogRef = this.dialog.open(VendorOffersComponent, {
      width: '540px',
      data: { vendorId: this.selectedId }
    });
  }

}
